module.exports = __webpack_public_path__ + "img/kkb_multicore.3661b430.jpg";